import React from 'react';
import ReactLogo from '../assets/img/react.svg';
import NextLogo from '../assets/img/nextjs.svg';
import ReduxLogo from '../assets/img/redux.svg';
import ReduxSagaLogo from '../assets/img/redux-saga.svg';
import ApolloLogo from '../assets/img/apollo.svg';
import GraphqlLogo from '../assets/img/graphql.svg';
import NodeLogo from '../assets/img/nodejs.svg';
import RedisLogo from '../assets/img/redis.svg';
import FirebaseLogo from '../assets/img/firebase.svg';
import TypescriptLogo from '../assets/img/typescript.svg';
import MysqlLogo from '../assets/img/mysql.svg';
import MongoDBLogo from '../assets/img/mongodb.svg';
import PostgreLogo from '../assets/img/postgresql.svg';
import PrismaLogo from '../assets/img/prisma.svg';
import AngularLogo from '../assets/img/angular.svg';
import ExpressLogo from '../assets/img/express.svg';
import JSLogo from '../assets/img/js.svg';
import VueJSLogo from '../assets/img/vuejs.svg';
import TailwindLogo from '../assets/img/tailwind.svg';
import MaterialUILogo from '../assets/img/materialUI.svg';

// export const SkillsData = [

   


//     {
//         animationName: "Web",
//         name: "Developpement Full Stack",
//         skills: [
//             {
//                 name: "Javascript",
//                 stacks: ['NodeJs','ReactJs', 'NextJS','VueJS','Angular','ExpressJS','Typescript']
//             },
//             {
//                 name: "Python",
//                 stacks: ['Django', 'DjangoRestFramework']
//             },
//             // {
//             //     name: "PHP",
//             //     stacks: ['Symfony', 'Laravel', 'CodeIgniter']
//             // },
//             {
//                 name: "Base de données",
//                 stacks: ['MySQL', 'Firebase/Firestore', 'MongoDB/Atlas', 'Postgresql']
//             },
//         ]
//     },



//     {
//         animationName: "Mobile",
//         name: "Developpement mobile",
//         skills: [
//             {
//                 name: "",
//                 stacks:["React Native"]
                
//             }  
//         ]
//     },



//     // {
//     //     animationName: "Blockchain",
//     //     name: "Developpement Blockchain",
//     //     skills: [
//     //         {
//     //             name: "",
//     //             stacks: ["Truffle", "Web3", "Ganache"]

//     //         }  
//     //     ]
//     // }


// ]

// export default SkillsData;



const technos = [
    {
        icon: <img src={JSLogo} alt="React Logo" />,
        name:'Javascript'
    },
    {
        icon: <img src={TypescriptLogo} alt="React Logo" />,
        name:'Typescript'
    },
    {
        icon: <img src={ReactLogo} alt="React Logo" />,
        name:'React/React native'
    },
    {
        icon: <img src={AngularLogo} alt="React Logo" />,
        name:'Angular'
    },
    {
        icon: <img src={VueJSLogo} alt="React Logo" />,
        name:'VueJS'
    },
    {
        icon: <img src={NextLogo} alt="React Logo" />,
        name:'Next'
    },
    {
        icon: <img src={ReduxLogo} alt="React Logo" />,
        name:'Redux'
    },
    {
        icon: <img src={ReduxSagaLogo} alt="React Logo" />,
        name:'Redux saga'
    },





    {
        icon: <img src={ApolloLogo} alt="React Logo" />,
        name:'Apollo'
    },
    {
        icon: <img src={GraphqlLogo} alt="React Logo" />,
        name:'GraphQl'
    },
    {
        icon: <img src={NodeLogo} alt="React Logo" />,
        name:'NodeJS'
    },
    {
        icon: <img src={ExpressLogo} alt="React Logo" />,
        name:'Express'
    },


    {
        icon: <img src={TailwindLogo} alt="React Logo" />,
        name:'Tailwind CSS'
    },
    {
        icon: <img src={MaterialUILogo} alt="React Logo" />,
        name:'Material-UI'
    },






    {
        icon: <img src={RedisLogo} alt="React Logo" />,
        name:'Redis'
    },
    {
        icon: <img src={FirebaseLogo} alt="React Logo" />,
        name:'Firebase'
    },
    
    {
        icon: <img src={MysqlLogo} alt="React Logo" />,
        name:'MySQL'
    },
    {
        icon: <img src={MongoDBLogo} alt="React Logo" />,
        name:'MongoDB'
    },
    {
        icon: <img src={PostgreLogo} alt="React Logo" />,
        name:'Postgresql'
    },
    {
        icon: <img src={PrismaLogo} alt="React Logo" />,
        name:'Prisma'
    },

]

export default technos;